import { isEmpty, without } from "lodash-es";
import { useState } from "react";

type Props<T> = {
  selected: T[];
  all: T[];
};

export const useToggleSelectAll = <T,>({ selected, all }: Props<T>) => {
  const [manuallySelectedAll, setManuallySelectedAll] = useState(false);

  const areAllSelected = selected.length === all.length;

  const toggle = (prevFilter: T[], option: T, checked: boolean) => {
    let nextSelected = checked
      ? areAllSelected
        ? [option]
        : [...prevFilter, option]
      : without(prevFilter, option);

    if (isEmpty(nextSelected)) {
      nextSelected = all;
    }

    setManuallySelectedAll(checked && prevFilter.length === all.length - 1);

    return nextSelected;
  };

  return {
    manuallySelectedAll,
    setManuallySelectedAll,
    areAllSelected,
    toggle,
  };
};
